// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/evaluation/v1/service.proto (package chalk.evaluation.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { ArchiveStatus } from "../../common/v1/archive_pb";
import { file_chalk_common_v1_archive } from "../../common/v1/archive_pb";
import { file_chalk_flags_v1_flags } from "../../flags/v1/flags_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/evaluation/v1/service.proto.
 */
export const file_chalk_evaluation_v1_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_common_v1_archive, file_chalk_flags_v1_flags, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.evaluation.v1.FunctionScorer
 */
export type FunctionScorer = Message<"chalk.evaluation.v1.FunctionScorer"> & {
  /**
   * @generated from field: string function_version_id = 1;
   */
  functionVersionId: string;
};

/**
 * Describes the message chalk.evaluation.v1.FunctionScorer.
 * Use `create(FunctionScorerSchema)` to create a new message.
 */
export const FunctionScorerSchema: GenMessage<FunctionScorer> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 0);

/**
 * @generated from message chalk.evaluation.v1.BuiltinScorer
 */
export type BuiltinScorer = Message<"chalk.evaluation.v1.BuiltinScorer"> & {
  /**
   * Built-in scorer implementations use immutable, versioned identifiers.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.evaluation.v1.BuiltinScorer.
 * Use `create(BuiltinScorerSchema)` to create a new message.
 */
export const BuiltinScorerSchema: GenMessage<BuiltinScorer> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 1);

/**
 * A scorer whose score is a ChalkSQL expression rather than a deployed
 * function. The expression is evaluated as a select item over the evaluation's
 * own relation, so it may reference any dataset column by name, plus `output`,
 * the task's result for the row.
 *
 * @generated from message chalk.evaluation.v1.SqlExpressionScorer
 */
export type SqlExpressionScorer = Message<"chalk.evaluation.v1.SqlExpressionScorer"> & {
  /**
   * Names the scorer in the UI and its _value and _error result
   * columns. The name is preserved unless it collides with another result column.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Valid wherever a select item is: what you could write between SELECT and
   * FROM against the dataset.
   *
   * @generated from field: string expression = 2;
   */
  expression: string;
};

/**
 * Describes the message chalk.evaluation.v1.SqlExpressionScorer.
 * Use `create(SqlExpressionScorerSchema)` to create a new message.
 */
export const SqlExpressionScorerSchema: GenMessage<SqlExpressionScorer> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 2);

/**
 * A task whose output is a ChalkSQL expression rather than a deployed
 * function's result. Nothing is called: the expression is evaluated as a select
 * item over the evaluation's dataset relation, so it may reference any dataset
 * column by name, and its value is the row's `output`.
 *
 * @generated from message chalk.evaluation.v1.SqlExpressionTask
 */
export type SqlExpressionTask = Message<"chalk.evaluation.v1.SqlExpressionTask"> & {
  /**
   * Valid wherever a select item is: what you could write between SELECT and
   * FROM against the dataset.
   *
   * @generated from field: string expression = 1;
   */
  expression: string;
};

/**
 * Describes the message chalk.evaluation.v1.SqlExpressionTask.
 * Use `create(SqlExpressionTaskSchema)` to create a new message.
 */
export const SqlExpressionTaskSchema: GenMessage<SqlExpressionTask> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 3);

/**
 * @generated from message chalk.evaluation.v1.EvaluationScorerSpec
 */
export type EvaluationScorerSpec = Message<"chalk.evaluation.v1.EvaluationScorerSpec"> & {
  /**
   * @generated from oneof chalk.evaluation.v1.EvaluationScorerSpec.implementation
   */
  implementation: {
    /**
     * @generated from field: chalk.evaluation.v1.FunctionScorer function = 1;
     */
    value: FunctionScorer;
    case: "function";
  } | {
    /**
     * @generated from field: chalk.evaluation.v1.BuiltinScorer builtin = 2;
     */
    value: BuiltinScorer;
    case: "builtin";
  } | {
    /**
     * @generated from field: chalk.evaluation.v1.SqlExpressionScorer sql_expression = 3;
     */
    value: SqlExpressionScorer;
    case: "sqlExpression";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationScorerSpec.
 * Use `create(EvaluationScorerSpecSchema)` to create a new message.
 */
export const EvaluationScorerSpecSchema: GenMessage<EvaluationScorerSpec> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 4);

/**
 * @generated from message chalk.evaluation.v1.EvaluationScorer
 */
export type EvaluationScorer = Message<"chalk.evaluation.v1.EvaluationScorer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationScorerSpec spec = 2;
   */
  spec?: EvaluationScorerSpec;
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationScorer.
 * Use `create(EvaluationScorerSchema)` to create a new message.
 */
export const EvaluationScorerSchema: GenMessage<EvaluationScorer> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 5);

/**
 * Wrapper persisted as deterministic protobuf bytes in the metadata database.
 *
 * @generated from message chalk.evaluation.v1.EvaluationScorers
 */
export type EvaluationScorers = Message<"chalk.evaluation.v1.EvaluationScorers"> & {
  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScorer scorers = 1;
   */
  scorers: EvaluationScorer[];
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationScorers.
 * Use `create(EvaluationScorersSchema)` to create a new message.
 */
export const EvaluationScorersSchema: GenMessage<EvaluationScorers> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 6);

/**
 * @generated from message chalk.evaluation.v1.EvaluationScorerScoreSummary
 */
export type EvaluationScorerScoreSummary = Message<"chalk.evaluation.v1.EvaluationScorerScoreSummary"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationScorer scorer = 1;
   */
  scorer?: EvaluationScorer;

  /**
   * @generated from field: optional double average_score = 2;
   */
  averageScore?: number;

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationValueDistribution distribution = 3;
   */
  distribution?: EvaluationValueDistribution;
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationScorerScoreSummary.
 * Use `create(EvaluationScorerScoreSummarySchema)` to create a new message.
 */
export const EvaluationScorerScoreSummarySchema: GenMessage<EvaluationScorerScoreSummary> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 7);

/**
 * Percentile estimates over the finite values observed for one score or metric.
 * The summary ChalkSQL query scans the complete result relation and returns a
 * bounded aggregate result rather than sending every computed row to the API.
 *
 * @generated from message chalk.evaluation.v1.EvaluationValueDistribution
 */
export type EvaluationValueDistribution = Message<"chalk.evaluation.v1.EvaluationValueDistribution"> & {
  /**
   * @generated from field: optional double p5 = 1;
   */
  p5?: number;

  /**
   * @generated from field: optional double p25 = 2;
   */
  p25?: number;

  /**
   * @generated from field: optional double p50 = 3;
   */
  p50?: number;

  /**
   * @generated from field: optional double p75 = 4;
   */
  p75?: number;

  /**
   * @generated from field: optional double p95 = 5;
   */
  p95?: number;
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationValueDistribution.
 * Use `create(EvaluationValueDistributionSchema)` to create a new message.
 */
export const EvaluationValueDistributionSchema: GenMessage<EvaluationValueDistribution> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 8);

/**
 * Aggregates for one completed evaluation run. Metrics is intentionally
 * extensible so duration, token, error, and cost fields can be added without
 * changing the list-page response shape.
 *
 * @generated from message chalk.evaluation.v1.EvaluationScoreSummary
 */
export type EvaluationScoreSummary = Message<"chalk.evaluation.v1.EvaluationScoreSummary"> & {
  /**
   * @generated from field: string evaluation_id = 1;
   */
  evaluationId: string;

  /**
   * @generated from field: string evaluation_run_id = 2;
   */
  evaluationRunId: string;

  /**
   * @generated from field: optional double average_score = 3;
   */
  averageScore?: number;

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScorerScoreSummary scorer_scores = 4;
   */
  scorerScores: EvaluationScorerScoreSummary[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: map<string, double> metrics = 7;
   */
  metrics: { [key: string]: number };

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationValueDistribution score_distribution = 8;
   */
  scoreDistribution?: EvaluationValueDistribution;

  /**
   * @generated from field: map<string, chalk.evaluation.v1.EvaluationValueDistribution> metric_distributions = 9;
   */
  metricDistributions: { [key: string]: EvaluationValueDistribution };
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationScoreSummary.
 * Use `create(EvaluationScoreSummarySchema)` to create a new message.
 */
export const EvaluationScoreSummarySchema: GenMessage<EvaluationScoreSummary> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 9);

/**
 * @generated from message chalk.evaluation.v1.Evaluation
 */
export type Evaluation = Message<"chalk.evaluation.v1.Evaluation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string dataset_id = 5;
   */
  datasetId: string;

  /**
   * @generated from field: string dataset_revision_id = 6;
   */
  datasetRevisionId: string;

  /**
   * @generated from field: string task_function_version_id = 7;
   */
  taskFunctionVersionId: string;

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScorer scorers = 8;
   */
  scorers: EvaluationScorer[];

  /**
   * @generated from field: google.protobuf.Struct metadata = 9;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: optional string created_by = 10;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string suite_id = 12;
   */
  suiteId: string;

  /**
   * Set instead of task_function_version_id when the task is a SQL expression.
   *
   * @generated from field: chalk.evaluation.v1.SqlExpressionTask task_sql_expression = 13;
   */
  taskSqlExpression?: SqlExpressionTask;

  /**
   * @generated from field: optional chalk.common.v1.ArchiveStatus archive_status = 14;
   */
  archiveStatus?: ArchiveStatus;
};

/**
 * Describes the message chalk.evaluation.v1.Evaluation.
 * Use `create(EvaluationSchema)` to create a new message.
 */
export const EvaluationSchema: GenMessage<Evaluation> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 10);

/**
 * @generated from message chalk.evaluation.v1.EvaluationRun
 */
export type EvaluationRun = Message<"chalk.evaluation.v1.EvaluationRun"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string evaluation_id = 4;
   */
  evaluationId: string;

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRunStatus status = 5;
   */
  status: EvaluationRunStatus;

  /**
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: optional string created_by = 7;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp started_at = 9;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp completed_at = 10;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: optional string result_dataset_id = 11;
   */
  resultDatasetId?: string;

  /**
   * @generated from field: optional string result_dataset_revision_id = 12;
   */
  resultDatasetRevisionId?: string;

  /**
   * @generated from field: optional string error_message = 13;
   */
  errorMessage?: string;

  /**
   * At most one run per environment may be selected as its comparison baseline.
   *
   * @generated from field: bool is_baseline = 14;
   */
  isBaseline: boolean;

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRunExecutionMode execution_mode = 15;
   */
  executionMode: EvaluationRunExecutionMode;

  /**
   * The ChalkSQL query that computes this run's results. Its streaming preview and trace are
   * readable while the run is still in progress, before a result dataset exists.
   *
   * @generated from field: optional string sql_query_id = 16;
   */
  sqlQueryId?: string;

  /**
   * Overrides the definition's suite for this run; unset runs inherit it.
   *
   * @generated from field: optional string suite_id = 17;
   */
  suiteId?: string;

  /**
   * @generated from field: chalk.evaluation.v1.EvaluationScoreSummaryStatus score_summary_status = 18;
   */
  scoreSummaryStatus: EvaluationScoreSummaryStatus;
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationRun.
 * Use `create(EvaluationRunSchema)` to create a new message.
 */
export const EvaluationRunSchema: GenMessage<EvaluationRun> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 11);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationRequest
 */
export type CreateEvaluationRequest = Message<"chalk.evaluation.v1.CreateEvaluationRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string dataset_id = 2;
   */
  datasetId: string;

  /**
   * @generated from field: string dataset_revision_id = 3;
   */
  datasetRevisionId: string;

  /**
   * @generated from field: string task_function_version_id = 4;
   */
  taskFunctionVersionId: string;

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScorerSpec scorers = 5;
   */
  scorers: EvaluationScorerSpec[];

  /**
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * Resolve and pin the dataset's latest revision at creation time. Mutually
   * exclusive with dataset_id and dataset_revision_id.
   *
   * @generated from field: string dataset_name = 7;
   */
  datasetName: string;

  /**
   * Defaults to the environment's Default suite when omitted.
   *
   * @generated from field: optional string suite_id = 8;
   */
  suiteId?: string;

  /**
   * A SQL expression task. Exactly one of this and task_function_version_id is
   * set.
   *
   * @generated from field: chalk.evaluation.v1.SqlExpressionTask task_sql_expression = 9;
   */
  taskSqlExpression?: SqlExpressionTask;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationRequest.
 * Use `create(CreateEvaluationRequestSchema)` to create a new message.
 */
export const CreateEvaluationRequestSchema: GenMessage<CreateEvaluationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 12);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationResponse
 */
export type CreateEvaluationResponse = Message<"chalk.evaluation.v1.CreateEvaluationResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.Evaluation evaluation = 1;
   */
  evaluation?: Evaluation;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationResponse.
 * Use `create(CreateEvaluationResponseSchema)` to create a new message.
 */
export const CreateEvaluationResponseSchema: GenMessage<CreateEvaluationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 13);

/**
 * @generated from message chalk.evaluation.v1.GetEvaluationRequest
 */
export type GetEvaluationRequest = Message<"chalk.evaluation.v1.GetEvaluationRequest"> & {
  /**
   * @generated from field: string evaluation_id = 1;
   */
  evaluationId: string;
};

/**
 * Describes the message chalk.evaluation.v1.GetEvaluationRequest.
 * Use `create(GetEvaluationRequestSchema)` to create a new message.
 */
export const GetEvaluationRequestSchema: GenMessage<GetEvaluationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 14);

/**
 * @generated from message chalk.evaluation.v1.GetEvaluationResponse
 */
export type GetEvaluationResponse = Message<"chalk.evaluation.v1.GetEvaluationResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.Evaluation evaluation = 1;
   */
  evaluation?: Evaluation;
};

/**
 * Describes the message chalk.evaluation.v1.GetEvaluationResponse.
 * Use `create(GetEvaluationResponseSchema)` to create a new message.
 */
export const GetEvaluationResponseSchema: GenMessage<GetEvaluationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 15);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationsRequest
 */
export type ListEvaluationsRequest = Message<"chalk.evaluation.v1.ListEvaluationsRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: optional string suite_id = 3;
   */
  suiteId?: string;

  /**
   * @generated from field: chalk.evaluation.v1.ListEvaluationsFilters filters = 4;
   */
  filters?: ListEvaluationsFilters;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationsRequest.
 * Use `create(ListEvaluationsRequestSchema)` to create a new message.
 */
export const ListEvaluationsRequestSchema: GenMessage<ListEvaluationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 16);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationsFilters
 */
export type ListEvaluationsFilters = Message<"chalk.evaluation.v1.ListEvaluationsFilters"> & {
  /**
   * @generated from field: repeated string created_by = 1;
   */
  createdBy: string[];

  /**
   * @generated from field: string search = 2;
   */
  search: string;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationsFilters.
 * Use `create(ListEvaluationsFiltersSchema)` to create a new message.
 */
export const ListEvaluationsFiltersSchema: GenMessage<ListEvaluationsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 17);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationsResponse
 */
export type ListEvaluationsResponse = Message<"chalk.evaluation.v1.ListEvaluationsResponse"> & {
  /**
   * @generated from field: repeated chalk.evaluation.v1.Evaluation evaluations = 1;
   */
  evaluations: Evaluation[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScoreSummary score_summaries = 3;
   */
  scoreSummaries: EvaluationScoreSummary[];
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationsResponse.
 * Use `create(ListEvaluationsResponseSchema)` to create a new message.
 */
export const ListEvaluationsResponseSchema: GenMessage<ListEvaluationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 18);

/**
 * @generated from message chalk.evaluation.v1.ArchiveEvaluationRequest
 */
export type ArchiveEvaluationRequest = Message<"chalk.evaluation.v1.ArchiveEvaluationRequest"> & {
  /**
   * @generated from field: string evaluation_id = 1;
   */
  evaluationId: string;
};

/**
 * Describes the message chalk.evaluation.v1.ArchiveEvaluationRequest.
 * Use `create(ArchiveEvaluationRequestSchema)` to create a new message.
 */
export const ArchiveEvaluationRequestSchema: GenMessage<ArchiveEvaluationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 19);

/**
 * @generated from message chalk.evaluation.v1.ArchiveEvaluationResponse
 */
export type ArchiveEvaluationResponse = Message<"chalk.evaluation.v1.ArchiveEvaluationResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.Evaluation evaluation = 1;
   */
  evaluation?: Evaluation;
};

/**
 * Describes the message chalk.evaluation.v1.ArchiveEvaluationResponse.
 * Use `create(ArchiveEvaluationResponseSchema)` to create a new message.
 */
export const ArchiveEvaluationResponseSchema: GenMessage<ArchiveEvaluationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 20);

/**
 * @generated from message chalk.evaluation.v1.UnarchiveEvaluationRequest
 */
export type UnarchiveEvaluationRequest = Message<"chalk.evaluation.v1.UnarchiveEvaluationRequest"> & {
  /**
   * @generated from field: string evaluation_id = 1;
   */
  evaluationId: string;
};

/**
 * Describes the message chalk.evaluation.v1.UnarchiveEvaluationRequest.
 * Use `create(UnarchiveEvaluationRequestSchema)` to create a new message.
 */
export const UnarchiveEvaluationRequestSchema: GenMessage<UnarchiveEvaluationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 21);

/**
 * @generated from message chalk.evaluation.v1.UnarchiveEvaluationResponse
 */
export type UnarchiveEvaluationResponse = Message<"chalk.evaluation.v1.UnarchiveEvaluationResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.Evaluation evaluation = 1;
   */
  evaluation?: Evaluation;
};

/**
 * Describes the message chalk.evaluation.v1.UnarchiveEvaluationResponse.
 * Use `create(UnarchiveEvaluationResponseSchema)` to create a new message.
 */
export const UnarchiveEvaluationResponseSchema: GenMessage<UnarchiveEvaluationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 22);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationRunRequest
 */
export type CreateEvaluationRunRequest = Message<"chalk.evaluation.v1.CreateEvaluationRunRequest"> & {
  /**
   * @generated from field: string evaluation_id = 1;
   */
  evaluationId: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 2;
   */
  metadata?: JsonObject;

  /**
   * When omitted, EVALUATION_RUN_EXECUTION_MODE_WORKFLOW if the environment has a reachable
   * workflow orchestrator, otherwise EVALUATION_RUN_EXECUTION_MODE_ON_READ.
   *
   * @generated from field: optional chalk.evaluation.v1.EvaluationRunExecutionMode execution_mode = 3;
   */
  executionMode?: EvaluationRunExecutionMode;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationRunRequest.
 * Use `create(CreateEvaluationRunRequestSchema)` to create a new message.
 */
export const CreateEvaluationRunRequestSchema: GenMessage<CreateEvaluationRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 23);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationRunResponse
 */
export type CreateEvaluationRunResponse = Message<"chalk.evaluation.v1.CreateEvaluationRunResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRun evaluation_run = 1;
   */
  evaluationRun?: EvaluationRun;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationRunResponse.
 * Use `create(CreateEvaluationRunResponseSchema)` to create a new message.
 */
export const CreateEvaluationRunResponseSchema: GenMessage<CreateEvaluationRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 24);

/**
 * @generated from message chalk.evaluation.v1.RescoreEvaluationRunRequest
 */
export type RescoreEvaluationRunRequest = Message<"chalk.evaluation.v1.RescoreEvaluationRunRequest"> & {
  /**
   * The finished run to score again. Its result dataset supplies the rows, and
   * the task outputs and scores that are still current for the new run.
   *
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 2;
   */
  metadata?: JsonObject;

  /**
   * The evaluation to record the new run under, whose task and scorers it is
   * run with. Defaults to the rescored run's own evaluation. Naming another one
   * is how a run is scored with scorers, or a task, it was not created with:
   * create an evaluation with them and rescore the run into it. That
   * evaluation must use the rescored run's dataset revision, since the new run
   * reads its rows out of the rescored run's results. When it names the same
   * task, the task's outputs are reused; otherwise the task is called on those
   * rows. A scorer the rescored run already had is reused when it reads
   * nothing the task changed, and is called again only on the rows it failed
   * on. Every other scorer is called.
   *
   * @generated from field: optional string evaluation_id = 3;
   */
  evaluationId?: string;
};

/**
 * Describes the message chalk.evaluation.v1.RescoreEvaluationRunRequest.
 * Use `create(RescoreEvaluationRunRequestSchema)` to create a new message.
 */
export const RescoreEvaluationRunRequestSchema: GenMessage<RescoreEvaluationRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 25);

/**
 * @generated from message chalk.evaluation.v1.RescoreEvaluationRunResponse
 */
export type RescoreEvaluationRunResponse = Message<"chalk.evaluation.v1.RescoreEvaluationRunResponse"> & {
  /**
   * A run of the target evaluation, recorded like any other, whose values are
   * copied from the rescored run wherever they are unchanged.
   *
   * @generated from field: chalk.evaluation.v1.EvaluationRun evaluation_run = 1;
   */
  evaluationRun?: EvaluationRun;
};

/**
 * Describes the message chalk.evaluation.v1.RescoreEvaluationRunResponse.
 * Use `create(RescoreEvaluationRunResponseSchema)` to create a new message.
 */
export const RescoreEvaluationRunResponseSchema: GenMessage<RescoreEvaluationRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 26);

/**
 * @generated from message chalk.evaluation.v1.GetEvaluationRunRequest
 */
export type GetEvaluationRunRequest = Message<"chalk.evaluation.v1.GetEvaluationRunRequest"> & {
  /**
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;
};

/**
 * Describes the message chalk.evaluation.v1.GetEvaluationRunRequest.
 * Use `create(GetEvaluationRunRequestSchema)` to create a new message.
 */
export const GetEvaluationRunRequestSchema: GenMessage<GetEvaluationRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 27);

/**
 * @generated from message chalk.evaluation.v1.GetEvaluationRunResponse
 */
export type GetEvaluationRunResponse = Message<"chalk.evaluation.v1.GetEvaluationRunResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRun evaluation_run = 1;
   */
  evaluationRun?: EvaluationRun;

  /**
   * The run's aggregates, once it has succeeded and they have been computed; unset until then.
   *
   * @generated from field: chalk.evaluation.v1.EvaluationScoreSummary score_summary = 2;
   */
  scoreSummary?: EvaluationScoreSummary;
};

/**
 * Describes the message chalk.evaluation.v1.GetEvaluationRunResponse.
 * Use `create(GetEvaluationRunResponseSchema)` to create a new message.
 */
export const GetEvaluationRunResponseSchema: GenMessage<GetEvaluationRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 28);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationRunsRequest
 */
export type ListEvaluationRunsRequest = Message<"chalk.evaluation.v1.ListEvaluationRunsRequest"> & {
  /**
   * @generated from field: optional string evaluation_id = 1;
   */
  evaluationId?: string;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional string suite_id = 4;
   */
  suiteId?: string;

  /**
   * @generated from field: chalk.evaluation.v1.ListEvaluationRunsFilters filters = 5;
   */
  filters?: ListEvaluationRunsFilters;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationRunsRequest.
 * Use `create(ListEvaluationRunsRequestSchema)` to create a new message.
 */
export const ListEvaluationRunsRequestSchema: GenMessage<ListEvaluationRunsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 29);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationRunsFilters
 */
export type ListEvaluationRunsFilters = Message<"chalk.evaluation.v1.ListEvaluationRunsFilters"> & {
  /**
   * Deprecated: use exclude_experiment_runs, which it means.
   *
   * @generated from field: bool exclude_post_training_runs = 1 [deprecated = true];
   * @deprecated
   */
  excludePostTrainingRuns: boolean;

  /**
   * Leave out runs an experiment started: its rollouts and any run of its trained model. They
   * call a different model than the evaluation's task, so they say nothing about the evaluation
   * itself. Such runs carry `experiment_id` in their metadata.
   *
   * @generated from field: bool exclude_experiment_runs = 2;
   */
  excludeExperimentRuns: boolean;

  /**
   * Empty selects every status. Matching uses refreshed job state.
   *
   * @generated from field: repeated chalk.evaluation.v1.EvaluationRunStatus statuses = 3;
   */
  statuses: EvaluationRunStatus[];

  /**
   * @generated from field: repeated string evaluation_ids = 4;
   */
  evaluationIds: string[];

  /**
   * @generated from field: repeated string excluded_evaluation_ids = 5;
   */
  excludedEvaluationIds: string[];

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationRunStatus excluded_statuses = 6;
   */
  excludedStatuses: EvaluationRunStatus[];
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationRunsFilters.
 * Use `create(ListEvaluationRunsFiltersSchema)` to create a new message.
 */
export const ListEvaluationRunsFiltersSchema: GenMessage<ListEvaluationRunsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 30);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationRunsResponse
 */
export type ListEvaluationRunsResponse = Message<"chalk.evaluation.v1.ListEvaluationRunsResponse"> & {
  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationRun evaluation_runs = 1;
   */
  evaluationRuns: EvaluationRun[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;

  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationScoreSummary score_summaries = 3;
   */
  scoreSummaries: EvaluationScoreSummary[];

  /**
   * @generated from field: repeated chalk.evaluation.v1.Evaluation evaluations = 4;
   */
  evaluations: Evaluation[];
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationRunsResponse.
 * Use `create(ListEvaluationRunsResponseSchema)` to create a new message.
 */
export const ListEvaluationRunsResponseSchema: GenMessage<ListEvaluationRunsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 31);

/**
 * @generated from message chalk.evaluation.v1.SetEvaluationRunBaselineRequest
 */
export type SetEvaluationRunBaselineRequest = Message<"chalk.evaluation.v1.SetEvaluationRunBaselineRequest"> & {
  /**
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;
};

/**
 * Describes the message chalk.evaluation.v1.SetEvaluationRunBaselineRequest.
 * Use `create(SetEvaluationRunBaselineRequestSchema)` to create a new message.
 */
export const SetEvaluationRunBaselineRequestSchema: GenMessage<SetEvaluationRunBaselineRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 32);

/**
 * @generated from message chalk.evaluation.v1.SetEvaluationRunBaselineResponse
 */
export type SetEvaluationRunBaselineResponse = Message<"chalk.evaluation.v1.SetEvaluationRunBaselineResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRun evaluation_run = 1;
   */
  evaluationRun?: EvaluationRun;
};

/**
 * Describes the message chalk.evaluation.v1.SetEvaluationRunBaselineResponse.
 * Use `create(SetEvaluationRunBaselineResponseSchema)` to create a new message.
 */
export const SetEvaluationRunBaselineResponseSchema: GenMessage<SetEvaluationRunBaselineResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 33);

/**
 * @generated from message chalk.evaluation.v1.MoveEvaluationRunRequest
 */
export type MoveEvaluationRunRequest = Message<"chalk.evaluation.v1.MoveEvaluationRunRequest"> & {
  /**
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;

  /**
   * @generated from field: string suite_id = 2;
   */
  suiteId: string;
};

/**
 * Describes the message chalk.evaluation.v1.MoveEvaluationRunRequest.
 * Use `create(MoveEvaluationRunRequestSchema)` to create a new message.
 */
export const MoveEvaluationRunRequestSchema: GenMessage<MoveEvaluationRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 34);

/**
 * @generated from message chalk.evaluation.v1.MoveEvaluationRunResponse
 */
export type MoveEvaluationRunResponse = Message<"chalk.evaluation.v1.MoveEvaluationRunResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationRun evaluation_run = 1;
   */
  evaluationRun?: EvaluationRun;
};

/**
 * Describes the message chalk.evaluation.v1.MoveEvaluationRunResponse.
 * Use `create(MoveEvaluationRunResponseSchema)` to create a new message.
 */
export const MoveEvaluationRunResponseSchema: GenMessage<MoveEvaluationRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 35);

/**
 * @generated from message chalk.evaluation.v1.ArchiveEvaluationRunRequest
 */
export type ArchiveEvaluationRunRequest = Message<"chalk.evaluation.v1.ArchiveEvaluationRunRequest"> & {
  /**
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;
};

/**
 * Describes the message chalk.evaluation.v1.ArchiveEvaluationRunRequest.
 * Use `create(ArchiveEvaluationRunRequestSchema)` to create a new message.
 */
export const ArchiveEvaluationRunRequestSchema: GenMessage<ArchiveEvaluationRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 36);

/**
 * @generated from message chalk.evaluation.v1.ArchiveEvaluationRunResponse
 */
export type ArchiveEvaluationRunResponse = Message<"chalk.evaluation.v1.ArchiveEvaluationRunResponse"> & {
  /**
   * @generated from field: string evaluation_run_id = 1;
   */
  evaluationRunId: string;
};

/**
 * Describes the message chalk.evaluation.v1.ArchiveEvaluationRunResponse.
 * Use `create(ArchiveEvaluationRunResponseSchema)` to create a new message.
 */
export const ArchiveEvaluationRunResponseSchema: GenMessage<ArchiveEvaluationRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 37);

/**
 * @generated from message chalk.evaluation.v1.EvaluationSuite
 */
export type EvaluationSuite = Message<"chalk.evaluation.v1.EvaluationSuite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string created_by = 5;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Counts across all definitions in the suite, populated by ListEvaluationSuites.
   *
   * @generated from field: optional int64 evaluation_count = 7;
   */
  evaluationCount?: bigint;

  /**
   * Distinct input dataset IDs; revisions of the same dataset count once.
   *
   * @generated from field: optional int64 dataset_count = 8;
   */
  datasetCount?: bigint;

  /**
   * @generated from field: string description = 9;
   */
  description: string;
};

/**
 * Describes the message chalk.evaluation.v1.EvaluationSuite.
 * Use `create(EvaluationSuiteSchema)` to create a new message.
 */
export const EvaluationSuiteSchema: GenMessage<EvaluationSuite> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 38);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationSuiteRequest
 */
export type CreateEvaluationSuiteRequest = Message<"chalk.evaluation.v1.CreateEvaluationSuiteRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationSuiteRequest.
 * Use `create(CreateEvaluationSuiteRequestSchema)` to create a new message.
 */
export const CreateEvaluationSuiteRequestSchema: GenMessage<CreateEvaluationSuiteRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 39);

/**
 * @generated from message chalk.evaluation.v1.CreateEvaluationSuiteResponse
 */
export type CreateEvaluationSuiteResponse = Message<"chalk.evaluation.v1.CreateEvaluationSuiteResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationSuite suite = 1;
   */
  suite?: EvaluationSuite;
};

/**
 * Describes the message chalk.evaluation.v1.CreateEvaluationSuiteResponse.
 * Use `create(CreateEvaluationSuiteResponseSchema)` to create a new message.
 */
export const CreateEvaluationSuiteResponseSchema: GenMessage<CreateEvaluationSuiteResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 40);

/**
 * @generated from message chalk.evaluation.v1.UpdateEvaluationSuiteOperation
 */
export type UpdateEvaluationSuiteOperation = Message<"chalk.evaluation.v1.UpdateEvaluationSuiteOperation"> & {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;
};

/**
 * Describes the message chalk.evaluation.v1.UpdateEvaluationSuiteOperation.
 * Use `create(UpdateEvaluationSuiteOperationSchema)` to create a new message.
 */
export const UpdateEvaluationSuiteOperationSchema: GenMessage<UpdateEvaluationSuiteOperation> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 41);

/**
 * @generated from message chalk.evaluation.v1.UpdateEvaluationSuiteRequest
 */
export type UpdateEvaluationSuiteRequest = Message<"chalk.evaluation.v1.UpdateEvaluationSuiteRequest"> & {
  /**
   * @generated from field: string suite_id = 1;
   */
  suiteId: string;

  /**
   * @generated from field: chalk.evaluation.v1.UpdateEvaluationSuiteOperation update = 2;
   */
  update?: UpdateEvaluationSuiteOperation;

  /**
   * Required and nonempty. Paths are relative to update; masked fields must be set.
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 3;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message chalk.evaluation.v1.UpdateEvaluationSuiteRequest.
 * Use `create(UpdateEvaluationSuiteRequestSchema)` to create a new message.
 */
export const UpdateEvaluationSuiteRequestSchema: GenMessage<UpdateEvaluationSuiteRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 42);

/**
 * @generated from message chalk.evaluation.v1.UpdateEvaluationSuiteResponse
 */
export type UpdateEvaluationSuiteResponse = Message<"chalk.evaluation.v1.UpdateEvaluationSuiteResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.EvaluationSuite suite = 1;
   */
  suite?: EvaluationSuite;
};

/**
 * Describes the message chalk.evaluation.v1.UpdateEvaluationSuiteResponse.
 * Use `create(UpdateEvaluationSuiteResponseSchema)` to create a new message.
 */
export const UpdateEvaluationSuiteResponseSchema: GenMessage<UpdateEvaluationSuiteResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 43);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationSuitesRequest
 */
export type ListEvaluationSuitesRequest = Message<"chalk.evaluation.v1.ListEvaluationSuitesRequest"> & {
  /**
   * @generated from field: chalk.evaluation.v1.ListEvaluationSuitesFilters filters = 1;
   */
  filters?: ListEvaluationSuitesFilters;

  /**
   * When set, sort by creation time in this direction. Otherwise preserve the
   * Default-suite-first ordering used by suite selectors.
   *
   * @generated from field: optional bool created_at_ascending = 2;
   */
  createdAtAscending?: boolean;

  /**
   * Omit both pagination fields to return every suite for selectors.
   *
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationSuitesRequest.
 * Use `create(ListEvaluationSuitesRequestSchema)` to create a new message.
 */
export const ListEvaluationSuitesRequestSchema: GenMessage<ListEvaluationSuitesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 44);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationSuitesFilters
 */
export type ListEvaluationSuitesFilters = Message<"chalk.evaluation.v1.ListEvaluationSuitesFilters"> & {
  /**
   * @generated from field: repeated string created_by = 1;
   */
  createdBy: string[];

  /**
   * @generated from field: string search = 2;
   */
  search: string;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationSuitesFilters.
 * Use `create(ListEvaluationSuitesFiltersSchema)` to create a new message.
 */
export const ListEvaluationSuitesFiltersSchema: GenMessage<ListEvaluationSuitesFilters> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 45);

/**
 * @generated from message chalk.evaluation.v1.ListEvaluationSuitesResponse
 */
export type ListEvaluationSuitesResponse = Message<"chalk.evaluation.v1.ListEvaluationSuitesResponse"> & {
  /**
   * @generated from field: repeated chalk.evaluation.v1.EvaluationSuite suites = 1;
   */
  suites: EvaluationSuite[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.evaluation.v1.ListEvaluationSuitesResponse.
 * Use `create(ListEvaluationSuitesResponseSchema)` to create a new message.
 */
export const ListEvaluationSuitesResponseSchema: GenMessage<ListEvaluationSuitesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 46);

/**
 * Selects which units of the evaluator's scope are scored.
 *
 * @generated from message chalk.evaluation.v1.OnlineEvaluatorPredicate
 */
export type OnlineEvaluatorPredicate = Message<"chalk.evaluation.v1.OnlineEvaluatorPredicate"> & {
  /**
   * A ChalkSQL boolean expression over the scope's telemetry table, written as
   * it would appear after WHERE: for span scope, any `telemetry.spans` column
   * by name, e.g. `openinference_span_kind = 'LLM' AND llm_model_name LIKE
   * 'claude-%'`. Empty matches every unit.
   *
   * @generated from field: string sql_expression = 1;
   */
  sqlExpression: string;
};

/**
 * Describes the message chalk.evaluation.v1.OnlineEvaluatorPredicate.
 * Use `create(OnlineEvaluatorPredicateSchema)` to create a new message.
 */
export const OnlineEvaluatorPredicateSchema: GenMessage<OnlineEvaluatorPredicate> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 47);

/**
 * @generated from message chalk.evaluation.v1.OnlineEvaluatorScorer
 */
export type OnlineEvaluatorScorer = Message<"chalk.evaluation.v1.OnlineEvaluatorScorer"> & {
  /**
   * Unique within the evaluator. Names the scorer's result, and is how another
   * scorer names this one in `depends_on`.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * A SQL expression spec's own name must be empty or equal `name`.
   *
   * @generated from field: chalk.evaluation.v1.EvaluationScorerSpec spec = 2;
   */
  spec?: EvaluationScorerSpec;

  /**
   * Scorers whose outputs this one receives. A function scorer receives each
   * as the argument of the same name; a SQL expression scorer may reference
   * each as a column of the same name. Its other inputs are columns of the
   * scope's telemetry table. The dependency graph must be acyclic.
   *
   * @generated from field: repeated string depends_on = 3;
   */
  dependsOn: string[];
};

/**
 * Describes the message chalk.evaluation.v1.OnlineEvaluatorScorer.
 * Use `create(OnlineEvaluatorScorerSchema)` to create a new message.
 */
export const OnlineEvaluatorScorerSchema: GenMessage<OnlineEvaluatorScorer> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 48);

/**
 * What an online evaluator does, as written by its author. Telemetry that
 * matches `predicate` is sampled at `sample_rate`, then scored by `scorers`.
 *
 * @generated from message chalk.evaluation.v1.OnlineEvaluatorSpec
 */
export type OnlineEvaluatorSpec = Message<"chalk.evaluation.v1.OnlineEvaluatorSpec"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.evaluation.v1.OnlineEvaluatorScorer scorers = 2;
   */
  scorers: OnlineEvaluatorScorer[];

  /**
   * @generated from field: chalk.evaluation.v1.OnlineEvaluatorPredicate predicate = 3;
   */
  predicate?: OnlineEvaluatorPredicate;

  /**
   * Defaults to ONLINE_EVALUATOR_SCOPE_SPAN.
   *
   * @generated from field: chalk.evaluation.v1.OnlineEvaluatorScope scope = 4;
   */
  scope: OnlineEvaluatorScope;

  /**
   * Fraction of matching units to score, in (0, 1]. Defaults to 1. Sampling is
   * decided per unit id, so a unit is either always or never in the sample.
   *
   * @generated from field: optional double sample_rate = 5;
   */
  sampleRate?: number;

  /**
   * A disabled evaluator keeps its definition but scores nothing.
   *
   * @generated from field: bool enabled = 6;
   */
  enabled: boolean;

  /**
   * @generated from field: google.protobuf.Struct metadata = 7;
   */
  metadata?: JsonObject;
};

/**
 * Describes the message chalk.evaluation.v1.OnlineEvaluatorSpec.
 * Use `create(OnlineEvaluatorSpecSchema)` to create a new message.
 */
export const OnlineEvaluatorSpecSchema: GenMessage<OnlineEvaluatorSpec> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 49);

/**
 * @generated from message chalk.evaluation.v1.OnlineEvaluator
 */
export type OnlineEvaluator = Message<"chalk.evaluation.v1.OnlineEvaluator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * Stored with defaults applied: scope and sample_rate are always set.
   *
   * @generated from field: chalk.evaluation.v1.OnlineEvaluatorSpec spec = 4;
   */
  spec?: OnlineEvaluatorSpec;

  /**
   * Starts at 1 and increments on every update, so a score can be attributed
   * to the definition that produced it.
   *
   * @generated from field: int64 revision = 5;
   */
  revision: bigint;

  /**
   * @generated from field: optional string created_by = 6;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message chalk.evaluation.v1.OnlineEvaluator.
 * Use `create(OnlineEvaluatorSchema)` to create a new message.
 */
export const OnlineEvaluatorSchema: GenMessage<OnlineEvaluator> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 50);

/**
 * @generated from message chalk.evaluation.v1.CreateOnlineEvaluatorRequest
 */
export type CreateOnlineEvaluatorRequest = Message<"chalk.evaluation.v1.CreateOnlineEvaluatorRequest"> & {
  /**
   * @generated from field: chalk.evaluation.v1.OnlineEvaluatorSpec spec = 1;
   */
  spec?: OnlineEvaluatorSpec;
};

/**
 * Describes the message chalk.evaluation.v1.CreateOnlineEvaluatorRequest.
 * Use `create(CreateOnlineEvaluatorRequestSchema)` to create a new message.
 */
export const CreateOnlineEvaluatorRequestSchema: GenMessage<CreateOnlineEvaluatorRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 51);

/**
 * @generated from message chalk.evaluation.v1.CreateOnlineEvaluatorResponse
 */
export type CreateOnlineEvaluatorResponse = Message<"chalk.evaluation.v1.CreateOnlineEvaluatorResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.OnlineEvaluator online_evaluator = 1;
   */
  onlineEvaluator?: OnlineEvaluator;
};

/**
 * Describes the message chalk.evaluation.v1.CreateOnlineEvaluatorResponse.
 * Use `create(CreateOnlineEvaluatorResponseSchema)` to create a new message.
 */
export const CreateOnlineEvaluatorResponseSchema: GenMessage<CreateOnlineEvaluatorResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 52);

/**
 * @generated from message chalk.evaluation.v1.GetOnlineEvaluatorRequest
 */
export type GetOnlineEvaluatorRequest = Message<"chalk.evaluation.v1.GetOnlineEvaluatorRequest"> & {
  /**
   * @generated from field: string online_evaluator_id = 1;
   */
  onlineEvaluatorId: string;
};

/**
 * Describes the message chalk.evaluation.v1.GetOnlineEvaluatorRequest.
 * Use `create(GetOnlineEvaluatorRequestSchema)` to create a new message.
 */
export const GetOnlineEvaluatorRequestSchema: GenMessage<GetOnlineEvaluatorRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 53);

/**
 * @generated from message chalk.evaluation.v1.GetOnlineEvaluatorResponse
 */
export type GetOnlineEvaluatorResponse = Message<"chalk.evaluation.v1.GetOnlineEvaluatorResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.OnlineEvaluator online_evaluator = 1;
   */
  onlineEvaluator?: OnlineEvaluator;
};

/**
 * Describes the message chalk.evaluation.v1.GetOnlineEvaluatorResponse.
 * Use `create(GetOnlineEvaluatorResponseSchema)` to create a new message.
 */
export const GetOnlineEvaluatorResponseSchema: GenMessage<GetOnlineEvaluatorResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 54);

/**
 * @generated from message chalk.evaluation.v1.ListOnlineEvaluatorsFilters
 */
export type ListOnlineEvaluatorsFilters = Message<"chalk.evaluation.v1.ListOnlineEvaluatorsFilters"> & {
  /**
   * When set, only evaluators whose `enabled` matches.
   *
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean;
};

/**
 * Describes the message chalk.evaluation.v1.ListOnlineEvaluatorsFilters.
 * Use `create(ListOnlineEvaluatorsFiltersSchema)` to create a new message.
 */
export const ListOnlineEvaluatorsFiltersSchema: GenMessage<ListOnlineEvaluatorsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 55);

/**
 * @generated from message chalk.evaluation.v1.ListOnlineEvaluatorsRequest
 */
export type ListOnlineEvaluatorsRequest = Message<"chalk.evaluation.v1.ListOnlineEvaluatorsRequest"> & {
  /**
   * @generated from field: optional string cursor = 1;
   */
  cursor?: string;

  /**
   * @generated from field: optional int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: chalk.evaluation.v1.ListOnlineEvaluatorsFilters filters = 3;
   */
  filters?: ListOnlineEvaluatorsFilters;
};

/**
 * Describes the message chalk.evaluation.v1.ListOnlineEvaluatorsRequest.
 * Use `create(ListOnlineEvaluatorsRequestSchema)` to create a new message.
 */
export const ListOnlineEvaluatorsRequestSchema: GenMessage<ListOnlineEvaluatorsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 56);

/**
 * @generated from message chalk.evaluation.v1.ListOnlineEvaluatorsResponse
 */
export type ListOnlineEvaluatorsResponse = Message<"chalk.evaluation.v1.ListOnlineEvaluatorsResponse"> & {
  /**
   * @generated from field: repeated chalk.evaluation.v1.OnlineEvaluator online_evaluators = 1;
   */
  onlineEvaluators: OnlineEvaluator[];

  /**
   * @generated from field: optional string next_cursor = 2;
   */
  nextCursor?: string;
};

/**
 * Describes the message chalk.evaluation.v1.ListOnlineEvaluatorsResponse.
 * Use `create(ListOnlineEvaluatorsResponseSchema)` to create a new message.
 */
export const ListOnlineEvaluatorsResponseSchema: GenMessage<ListOnlineEvaluatorsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 57);

/**
 * @generated from message chalk.evaluation.v1.UpdateOnlineEvaluatorRequest
 */
export type UpdateOnlineEvaluatorRequest = Message<"chalk.evaluation.v1.UpdateOnlineEvaluatorRequest"> & {
  /**
   * @generated from field: string online_evaluator_id = 1;
   */
  onlineEvaluatorId: string;

  /**
   * Replaces the evaluator's whole spec and increments its revision.
   *
   * @generated from field: chalk.evaluation.v1.OnlineEvaluatorSpec spec = 2;
   */
  spec?: OnlineEvaluatorSpec;

  /**
   * When set, the update applies only if the evaluator is still at this
   * revision, so concurrent editors cannot silently overwrite each other.
   *
   * @generated from field: optional int64 expected_revision = 3;
   */
  expectedRevision?: bigint;
};

/**
 * Describes the message chalk.evaluation.v1.UpdateOnlineEvaluatorRequest.
 * Use `create(UpdateOnlineEvaluatorRequestSchema)` to create a new message.
 */
export const UpdateOnlineEvaluatorRequestSchema: GenMessage<UpdateOnlineEvaluatorRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 58);

/**
 * @generated from message chalk.evaluation.v1.UpdateOnlineEvaluatorResponse
 */
export type UpdateOnlineEvaluatorResponse = Message<"chalk.evaluation.v1.UpdateOnlineEvaluatorResponse"> & {
  /**
   * @generated from field: chalk.evaluation.v1.OnlineEvaluator online_evaluator = 1;
   */
  onlineEvaluator?: OnlineEvaluator;
};

/**
 * Describes the message chalk.evaluation.v1.UpdateOnlineEvaluatorResponse.
 * Use `create(UpdateOnlineEvaluatorResponseSchema)` to create a new message.
 */
export const UpdateOnlineEvaluatorResponseSchema: GenMessage<UpdateOnlineEvaluatorResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 59);

/**
 * @generated from message chalk.evaluation.v1.DeleteOnlineEvaluatorRequest
 */
export type DeleteOnlineEvaluatorRequest = Message<"chalk.evaluation.v1.DeleteOnlineEvaluatorRequest"> & {
  /**
   * @generated from field: string online_evaluator_id = 1;
   */
  onlineEvaluatorId: string;
};

/**
 * Describes the message chalk.evaluation.v1.DeleteOnlineEvaluatorRequest.
 * Use `create(DeleteOnlineEvaluatorRequestSchema)` to create a new message.
 */
export const DeleteOnlineEvaluatorRequestSchema: GenMessage<DeleteOnlineEvaluatorRequest> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 60);

/**
 * @generated from message chalk.evaluation.v1.DeleteOnlineEvaluatorResponse
 */
export type DeleteOnlineEvaluatorResponse = Message<"chalk.evaluation.v1.DeleteOnlineEvaluatorResponse"> & {
  /**
   * @generated from field: string online_evaluator_id = 1;
   */
  onlineEvaluatorId: string;
};

/**
 * Describes the message chalk.evaluation.v1.DeleteOnlineEvaluatorResponse.
 * Use `create(DeleteOnlineEvaluatorResponseSchema)` to create a new message.
 */
export const DeleteOnlineEvaluatorResponseSchema: GenMessage<DeleteOnlineEvaluatorResponse> = /*@__PURE__*/
  messageDesc(file_chalk_evaluation_v1_service, 61);

/**
 * @generated from enum chalk.evaluation.v1.EvaluationRunStatus
 */
export enum EvaluationRunStatus {
  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: EVALUATION_RUN_STATUS_CANCELED = 5;
   */
  CANCELED = 5,

  /**
   * The SQL query succeeded and its output is being registered as a Dataset revision.
   *
   * @generated from enum value: EVALUATION_RUN_STATUS_FINALIZING = 6;
   */
  FINALIZING = 6,
}

/**
 * Describes the enum chalk.evaluation.v1.EvaluationRunStatus.
 */
export const EvaluationRunStatusSchema: GenEnum<EvaluationRunStatus> = /*@__PURE__*/
  enumDesc(file_chalk_evaluation_v1_service, 0);

/**
 * How a run's SQL query and score summary are driven to completion.
 *
 * @generated from enum chalk.evaluation.v1.EvaluationRunExecutionMode
 */
export enum EvaluationRunExecutionMode {
  /**
   * @generated from enum value: EVALUATION_RUN_EXECUTION_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The server reconciles the run's SQL job and computes its summary when the run is read.
   *
   * @generated from enum value: EVALUATION_RUN_EXECUTION_MODE_ON_READ = 1;
   */
  ON_READ = 1,

  /**
   * A workflow on the environment's workflow orchestrator watches the SQL job, waits for the
   * run's telemetry to land, and runs the summary as SQL jobs. Requires the environment to
   * have a workflow orchestrator.
   *
   * @generated from enum value: EVALUATION_RUN_EXECUTION_MODE_WORKFLOW = 2;
   */
  WORKFLOW = 2,
}

/**
 * Describes the enum chalk.evaluation.v1.EvaluationRunExecutionMode.
 */
export const EvaluationRunExecutionModeSchema: GenEnum<EvaluationRunExecutionMode> = /*@__PURE__*/
  enumDesc(file_chalk_evaluation_v1_service, 1);

/**
 * Summary computation completes independently of the run's row execution.
 *
 * @generated from enum chalk.evaluation.v1.EvaluationScoreSummaryStatus
 */
export enum EvaluationScoreSummaryStatus {
  /**
   * The run has not succeeded, so no summary is expected yet.
   *
   * @generated from enum value: EVALUATION_SCORE_SUMMARY_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVALUATION_SCORE_SUMMARY_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: EVALUATION_SCORE_SUMMARY_STATUS_READY = 2;
   */
  READY = 2,

  /**
   * Summary computation exhausted its retries; the run's results remain readable.
   *
   * @generated from enum value: EVALUATION_SCORE_SUMMARY_STATUS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * Describes the enum chalk.evaluation.v1.EvaluationScoreSummaryStatus.
 */
export const EvaluationScoreSummaryStatusSchema: GenEnum<EvaluationScoreSummaryStatus> = /*@__PURE__*/
  enumDesc(file_chalk_evaluation_v1_service, 2);

/**
 * The unit of telemetry an online evaluator judges. Each matching unit is
 * scored once, as one row.
 *
 * @generated from enum chalk.evaluation.v1.OnlineEvaluatorScope
 */
export enum OnlineEvaluatorScope {
  /**
   * Treated as ONLINE_EVALUATOR_SCOPE_SPAN.
   *
   * @generated from enum value: ONLINE_EVALUATOR_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * One row of `telemetry.spans`.
   *
   * @generated from enum value: ONLINE_EVALUATOR_SCOPE_SPAN = 1;
   */
  SPAN = 1,

  /**
   * One row of `telemetry.traces`. Not yet supported.
   *
   * @generated from enum value: ONLINE_EVALUATOR_SCOPE_TRACE = 2;
   */
  TRACE = 2,

  /**
   * One row of `telemetry.sessions`. Not yet supported.
   *
   * @generated from enum value: ONLINE_EVALUATOR_SCOPE_SESSION = 3;
   */
  SESSION = 3,
}

/**
 * Describes the enum chalk.evaluation.v1.OnlineEvaluatorScope.
 */
export const OnlineEvaluatorScopeSchema: GenEnum<OnlineEvaluatorScope> = /*@__PURE__*/
  enumDesc(file_chalk_evaluation_v1_service, 3);

/**
 * @generated from service chalk.evaluation.v1.EvaluationService
 */
export const EvaluationService: GenService<{
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluationSuite
   */
  createEvaluationSuite: {
    methodKind: "unary";
    input: typeof CreateEvaluationSuiteRequestSchema;
    output: typeof CreateEvaluationSuiteResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.UpdateEvaluationSuite
   */
  updateEvaluationSuite: {
    methodKind: "unary";
    input: typeof UpdateEvaluationSuiteRequestSchema;
    output: typeof UpdateEvaluationSuiteResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluationSuites
   */
  listEvaluationSuites: {
    methodKind: "unary";
    input: typeof ListEvaluationSuitesRequestSchema;
    output: typeof ListEvaluationSuitesResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluation
   */
  createEvaluation: {
    methodKind: "unary";
    input: typeof CreateEvaluationRequestSchema;
    output: typeof CreateEvaluationResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.GetEvaluation
   */
  getEvaluation: {
    methodKind: "unary";
    input: typeof GetEvaluationRequestSchema;
    output: typeof GetEvaluationResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluations
   */
  listEvaluations: {
    methodKind: "unary";
    input: typeof ListEvaluationsRequestSchema;
    output: typeof ListEvaluationsResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ArchiveEvaluation
   */
  archiveEvaluation: {
    methodKind: "unary";
    input: typeof ArchiveEvaluationRequestSchema;
    output: typeof ArchiveEvaluationResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.UnarchiveEvaluation
   */
  unarchiveEvaluation: {
    methodKind: "unary";
    input: typeof UnarchiveEvaluationRequestSchema;
    output: typeof UnarchiveEvaluationResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateEvaluationRun
   */
  createEvaluationRun: {
    methodKind: "unary";
    input: typeof CreateEvaluationRunRequestSchema;
    output: typeof CreateEvaluationRunResponseSchema;
  },
  /**
   * Score a finished run's rows again, with its own evaluation's task and
   * scorers or with another evaluation's over the same dataset revision. Only
   * what changed since that run is called: the task's outputs are read back out
   * of the rescored run when the evaluation names the same task, and a scorer's
   * values are copied from it when the run had the same scorer over the same
   * inputs, except on the rows that scorer failed on.
   *
   * @generated from rpc chalk.evaluation.v1.EvaluationService.RescoreEvaluationRun
   */
  rescoreEvaluationRun: {
    methodKind: "unary";
    input: typeof RescoreEvaluationRunRequestSchema;
    output: typeof RescoreEvaluationRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.GetEvaluationRun
   */
  getEvaluationRun: {
    methodKind: "unary";
    input: typeof GetEvaluationRunRequestSchema;
    output: typeof GetEvaluationRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ListEvaluationRuns
   */
  listEvaluationRuns: {
    methodKind: "unary";
    input: typeof ListEvaluationRunsRequestSchema;
    output: typeof ListEvaluationRunsResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.SetEvaluationRunBaseline
   */
  setEvaluationRunBaseline: {
    methodKind: "unary";
    input: typeof SetEvaluationRunBaselineRequestSchema;
    output: typeof SetEvaluationRunBaselineResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.MoveEvaluationRun
   */
  moveEvaluationRun: {
    methodKind: "unary";
    input: typeof MoveEvaluationRunRequestSchema;
    output: typeof MoveEvaluationRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ArchiveEvaluationRun
   */
  archiveEvaluationRun: {
    methodKind: "unary";
    input: typeof ArchiveEvaluationRunRequestSchema;
    output: typeof ArchiveEvaluationRunResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.CreateOnlineEvaluator
   */
  createOnlineEvaluator: {
    methodKind: "unary";
    input: typeof CreateOnlineEvaluatorRequestSchema;
    output: typeof CreateOnlineEvaluatorResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.GetOnlineEvaluator
   */
  getOnlineEvaluator: {
    methodKind: "unary";
    input: typeof GetOnlineEvaluatorRequestSchema;
    output: typeof GetOnlineEvaluatorResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.ListOnlineEvaluators
   */
  listOnlineEvaluators: {
    methodKind: "unary";
    input: typeof ListOnlineEvaluatorsRequestSchema;
    output: typeof ListOnlineEvaluatorsResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.UpdateOnlineEvaluator
   */
  updateOnlineEvaluator: {
    methodKind: "unary";
    input: typeof UpdateOnlineEvaluatorRequestSchema;
    output: typeof UpdateOnlineEvaluatorResponseSchema;
  },
  /**
   * @generated from rpc chalk.evaluation.v1.EvaluationService.DeleteOnlineEvaluator
   */
  deleteOnlineEvaluator: {
    methodKind: "unary";
    input: typeof DeleteOnlineEvaluatorRequestSchema;
    output: typeof DeleteOnlineEvaluatorResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_evaluation_v1_service, 0);

